import { Stack } from '@mui/material'
import React from 'react'

import { TestSuiteTeamSelection } from 'components/test-suites/forms/TestSuiteTeamSelection'
import { TestSuiteTeamTable } from 'components/test-suites/forms/TestSuiteTeamTable'
import { getCanCreateAndEditTestSuites } from 'components/test-suites/test-suites-utils'
import useAuth from 'hooks/use-auth'
import { type Team } from 'types/api/teams'

export const TestSuiteAddTeams: React.FC<{
  isDefaultTestSuite: boolean
  teams: Team[]
}> = ({ isDefaultTestSuite, teams }) => {
  const { hasEndpointAccess } = useAuth()

  const canCreateAndEditTestSuites =
    getCanCreateAndEditTestSuites(hasEndpointAccess)

  return (
    <Stack spacing={2}>
      {canCreateAndEditTestSuites && <TestSuiteTeamSelection teams={teams} />}
      <TestSuiteTeamTable
        canEdit={canCreateAndEditTestSuites}
        isDefaultTestSuite={isDefaultTestSuite}
        teams={teams}
      />
    </Stack>
  )
}
